module.exports = __webpack_public_path__ + "img/89.9b147de1.jpg";